"use strict";
exports.__esModule = true;
exports.chart_donut_utilization_dynamic_pie_Height = {
  "name": "--pf-chart-donut--utilization--dynamic--pie--Height",
  "value": 230,
  "var": "var(--pf-chart-donut--utilization--dynamic--pie--Height, 230)"
};
exports["default"] = exports.chart_donut_utilization_dynamic_pie_Height;